var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"280px"}},[_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }